import { __generator } from "tslib";
import ddt from '@wix/da-ddt';
import { all, call, put, race, select, take, takeLatest, } from 'redux-saga/effects';
import { actions as modalActions } from '../../Modals';
import { getIsLoggedIn, getIsVerificationNeeded, } from '../../publicSession/selectors';
import { restrictLoggedOut } from '../../redux/loggedout';
import { actions as userActions } from '../../redux/users';
import { pushVerificationPopup } from '../../VerificationPopup/actions';
import { showReportModal, unblockDeviationAuthor, hideDeviation, unhideDeviation, unhideDeviationFail, unhideDeviationSuccess, blockDeviationAuthor, hideDeviationFail, hideDeviationSuccess, } from './actions';
import { ModalType } from '../../Modals/redux/types';
import { request } from '../../xhr';
import { ReferralType } from '@wix/da-bi/pkg/constants';
var logger = ddt.createLogger('moderation');
// TODO: all changes to blocked state should be reflected in entities
// however we can't rely fully on that as there are places without
// normalization. So also need to update browse etc. to normalize
// For now, all this is blissfully ignored here, so devpage will
// reflect the changes but parent not
function doUnhideDeviation(deviationid) {
    var data, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                data = {
                    deviationid: deviationid,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'deviation/unhide',
                        data: data,
                    }, function () { return ({ success: true }); })];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result && result.success];
        }
    });
}
function doHideDeviation(deviationid) {
    var data, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                data = {
                    deviationid: deviationid,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'deviation/hide',
                        data: data,
                    }, function () { return ({ success: true }); })];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result && result.success];
        }
    });
}
function handleHideDeviation(_a) {
    var isLoggedIn, success;
    var deviationId = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(getIsLoggedIn)];
            case 1:
                isLoggedIn = _b.sent();
                if (!!isLoggedIn) return [3 /*break*/, 3];
                return [4 /*yield*/, put(restrictLoggedOut({ restrictedActionName: ReferralType.REPORT }))];
            case 2:
                _b.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, call(doHideDeviation, deviationId)];
            case 4:
                success = _b.sent();
                if (!!success) return [3 /*break*/, 6];
                return [4 /*yield*/, put(hideDeviationFail(deviationId))];
            case 5:
                _b.sent();
                return [2 /*return*/];
            case 6: return [4 /*yield*/, put(hideDeviationSuccess(deviationId))];
            case 7:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function handleUnhideDeviation(_a) {
    var isLoggedIn, success;
    var deviationId = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(getIsLoggedIn)];
            case 1:
                isLoggedIn = _b.sent();
                if (!!isLoggedIn) return [3 /*break*/, 3];
                return [4 /*yield*/, put(restrictLoggedOut({ restrictedActionName: ReferralType.REPORT }))];
            case 2:
                _b.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, call(doUnhideDeviation, deviationId)];
            case 4:
                success = _b.sent();
                if (!!success) return [3 /*break*/, 6];
                return [4 /*yield*/, put(unhideDeviationFail(deviationId))];
            case 5:
                _b.sent();
                return [2 /*return*/];
            case 6: return [4 /*yield*/, put(unhideDeviationSuccess(deviationId))];
            case 7:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function handleUnblockDeviant(_a) {
    var isLoggedIn, fail;
    var _b = _a.payload, userId = _b.userId, deviationId = _b.deviationId;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!userId) {
                    logger.warn('Attempted unblock deviant without userId');
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(getIsLoggedIn)];
            case 1:
                isLoggedIn = _c.sent();
                if (!!isLoggedIn) return [3 /*break*/, 3];
                return [4 /*yield*/, put(restrictLoggedOut({ restrictedActionName: ReferralType.REPORT }))];
            case 2:
                _c.sent();
                return [2 /*return*/];
            case 3: 
            // here we kick off the shared unblock process
            return [4 /*yield*/, put(userActions.unblockUser(userId))];
            case 4:
                // here we kick off the shared unblock process
                _c.sent();
                return [4 /*yield*/, race({
                        success: take(function (resultAction) {
                            return resultAction.type === userActions.unblockUserSuccess.toString() &&
                                resultAction.payload === userId;
                        }),
                        fail: take(function (resultAction) {
                            return resultAction.type === userActions.unblockUserFail.toString() &&
                                resultAction.payload === userId;
                        }),
                    })];
            case 5:
                fail = (_c.sent()).fail;
                if (fail) {
                    // if unblocking failed, nothing to do here, life sucks
                    return [2 /*return*/];
                }
                // and so, we succeeded unblocking the user, now to unhide the originating deviation
                return [4 /*yield*/, call(handleUnhideDeviation, unhideDeviation(deviationId))];
            case 6:
                // and so, we succeeded unblocking the user, now to unhide the originating deviation
                _c.sent();
                return [2 /*return*/];
        }
    });
}
function handleBlockDeviant(_a) {
    var user = _a.payload.user;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, put(modalActions.pushModal(ModalType.USER_BLOCK, {
                    wrapInModal: true,
                    params: { user: user },
                }))];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function handleShowReportModal(_a) {
    var isLoggedIn, deviationId;
    var deviation = _a.payload.deviation;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(function (state) { return ({
                    isLoggedIn: getIsLoggedIn(state),
                    isVerificationNeeded: getIsVerificationNeeded(state),
                }); })];
            case 1:
                isLoggedIn = (_b.sent()).isLoggedIn;
                if (!!isLoggedIn) return [3 /*break*/, 3];
                return [4 /*yield*/, put(restrictLoggedOut({ restrictedActionName: ReferralType.REPORT }))];
            case 2:
                _b.sent();
                return [2 /*return*/];
            case 3:
                if (!!getIsVerificationNeeded) return [3 /*break*/, 5];
                return [4 /*yield*/, put(pushVerificationPopup('report'))];
            case 4:
                _b.sent();
                return [2 /*return*/];
            case 5:
                deviationId = deviation.deviationId;
                return [4 /*yield*/, put(modalActions.pushModal(ModalType.REPORT_DEVIATION_MODAL, {
                        wrapInModal: true,
                        params: { deviationId: deviationId },
                    }))];
            case 6:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
export default function moderationRootSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeLatest(showReportModal, handleShowReportModal),
                    takeLatest(hideDeviation, handleHideDeviation),
                    takeLatest(unhideDeviation, handleUnhideDeviation),
                    takeLatest(unblockDeviationAuthor, handleUnblockDeviant),
                    takeLatest(blockDeviationAuthor, handleBlockDeviant),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map